import { useQuery } from "@tanstack/react-query";
import {
  mvpApiListPlanograms,
  PagedPlanogramSchema,
} from "@labeling-tools/api/atlas";

export function useAtlasPlanograms(storeId: string | null | undefined = null) {
  return useQuery({
    queryKey: ["fetch-atlas-planograms", storeId],
    queryFn: async () => {
      const response = await mvpApiListPlanograms({
        query: {
          store_id: storeId || "",
          finalized: true,
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch product: ${response.error}`);
      }

      return response.data as PagedPlanogramSchema;
    },
    enabled: !!storeId,
  });
}
